import { render, staticRenderFns } from "./CustomerCards.vue?vue&type=template&id=43cc3e7d&scoped=true"
import script from "./CustomerCards.vue?vue&type=script&lang=js"
export * from "./CustomerCards.vue?vue&type=script&lang=js"
import style0 from "./CustomerCards.vue?vue&type=style&index=0&id=43cc3e7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cc3e7d",
  null
  
)

export default component.exports